// ═══════════════════════════════════════════════════════════════════
//  PlatformImportV39 — dua kepingan kecil untuk Import Products berbilang platform
//
//  • <TabPlatformImport>  baris pilih platform (TikTok | Shopee) di atas langkah Setup.
//                         Dua platform = dua komponen stepper BERASINGAN
//                         (ImportStepperV39 = TikTok, ImportShopeeV39 = Shopee) —
//                         keputusan user 3 Okt 2026: "kena ada 2 tab, jangan campur".
//  • <TandaPlatform>      tanda kecil pada baris/kad My Products: TikTok, Shopee,
//                         atau kedua-duanya (peraturan dalam `platformItem`).
//
//  Rupa v3.9: monokrom, tanpa emoji; warna melalui token `--s-…`.
// ═══════════════════════════════════════════════════════════════════
import { platformItem } from '../utils/shopeeImport';

const GAYA = `
.pfi-tabs{display:flex;gap:6px;margin-bottom:10px;}
.pfi-tab{flex:1;font-size:13px;font-weight:700;padding:9px 8px;border-radius:9px;border:1px solid var(--s-line);background:var(--s-card);color:var(--s-ink-2);cursor:pointer;}
.pfi-tab:hover{background:var(--s-fill);}
.pfi-tab.on{background:var(--s-ink);color:var(--s-card);border-color:var(--s-ink);}
.pfi-tanda{display:inline-flex;gap:4px;flex-wrap:wrap;vertical-align:middle;}
.pfi-pil{font-size:10.5px;font-weight:700;line-height:1;padding:4px 9px;border-radius:6px;border:1px solid transparent;white-space:nowrap;}
.pfi-pil--tiktok{background:var(--s-ink);color:var(--s-card);}
.pfi-pil--shopee{background:#EE4D2D;color:#fff;}
`;
/* ★ Warna platform (arahan user 3 Okt 2026: "button berwarna untuk bezakan TikTok / Shopee") —
   pengecualian SENGAJA kepada rupa v3.9 monokrom. TikTok = dakwat tema (hitam pada tema
   cerah, terbalik sendiri pada tema gelap); Shopee = oren jenama, tetap pada kedua-dua tema. */

// CSS dipasang SEKALI pada dokumen — <TandaPlatform> dirender pada setiap baris produk,
// jadi <style> per-komponen akan menjadi ratusan salinan.
function pasangGaya() {
    if (typeof document === 'undefined') return;
    const sedia = document.getElementById('pfi-gaya');
    if (sedia) { if (sedia.textContent !== GAYA) sedia.textContent = GAYA; return; }
    const el = document.createElement('style');
    el.id = 'pfi-gaya';
    el.textContent = GAYA;
    document.head.appendChild(el);
}

const PLATFORM = [
    { id: 'tiktok', label: 'TikTok' },
    { id: 'shopee', label: 'Shopee' },
];

export function TabPlatformImport({ platform, onTukar }) {
    pasangGaya();
    return (
        <div className="pfi-tabs" role="tablist" aria-label="Platform">
            {PLATFORM.map((p) => (
                <button
                    key={p.id}
                    type="button"
                    role="tab"
                    aria-selected={platform === p.id}
                    className={`pfi-tab${platform === p.id ? ' on' : ''}`}
                    onClick={() => { if (platform !== p.id) onTukar?.(p.id); }}
                >
                    {p.label}
                </button>
            ))}
        </div>
    );
}

export function TandaPlatform({ item, style }) {
    const { tiktok, shopee } = platformItem(item);
    if (!tiktok && !shopee) return null;
    pasangGaya();
    return (
        <span className="pfi-tanda" style={style}>
            {tiktok && <span className="pfi-pil pfi-pil--tiktok">TikTok</span>}
            {shopee && <span className="pfi-pil pfi-pil--shopee">Shopee</span>}
        </span>
    );
}
